import React from 'react';
import { IconButton, IconButtonProps } from '@mui/material';
import { MoreVert } from '@mui/icons-material';

type RowActionsButtonProps = Omit<IconButtonProps, 'children' | 'size' | 'sx'>;

/** Shared trigger for row-level overflow menus. */
const RowActionsButton: React.FC<RowActionsButtonProps> = props => (
  <IconButton
    {...props}
    size="small"
    sx={{ width: 44, height: 44, flexShrink: 0, color: 'text.secondary', border: 0 }}
  >
    <MoreVert fontSize="small" />
  </IconButton>
);

export default RowActionsButton;
